<template>
<div class="container">
  <auth-modal ref="authModal"></auth-modal>
  <div class="row">
    <div class="col big-margin">
      <h2 class="no-margin">Welcome to HomFAX!</h2>
    </div>
  </div>
  <div class="row">
    <div class="col big-margin">
      <p>HomFAX uses the MLS database to populate housing information. If your address does not appear on HomFAX, it is because your house has not been listed with your local MLS. That's ok! You can add your address and start tracking your HomFAX now!</p>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col">
      <h5><i class="fas fa-home"></i> Property Details</h5>
    </div>
  </div>
  <user-property-details v-bind:propertyCreation="true" v-on:create-property-user-not-logged-in="loginRequired" class="property-details"></user-property-details>
</div>
</template>

<script>
import { mapMutations } from 'vuex'
import AuthModal from '../../authentication/TheAuthModal.vue'
import UserPropertyDetails from './dropdowns/UserPropertyDetails.vue'

export default {
  components: {
    AuthModal,
    UserPropertyDetails
  },
  methods: {
    ...mapMutations('property', [
      'clearData'
    ]),
    loginRequired () {
      this.$refs.authModal.$refs.authModal.show()
    }
  },
  beforeRouteLeave (to, from, next) {
    this.clearData()
    next()
  }
}
</script>

<style scoped>
.big-margin {
  margin-left: 3rem;
  margin-right: 3rem;
  margin-top: 1rem;
}

.no-margin {
  margin: 0;
}

.property-details {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeData/PropertyCreationPage.vue